<template>
  <section class="advantage">
    <TheHeader />
    <section class="advantage__banner">
      <h1>Conheça os benefícios</h1>
    </section>

    <div class="limit-grid">
      <div class="advantage__wrapper">
        <div class="advantage__grid">
          <section class="advantage__grid__item" @click="goTo('saude')">
            <div class="advantage__grid__item__wrapper">
              <img src="@/assets/beneficios/saude.svg" alt />
              <h2>Saúde</h2>
            </div>
          </section>
          <section class="advantage__grid__item" @click="goTo('educacao')">
            <div class="advantage__grid__item__wrapper">
              <img src="@/assets/beneficios/educacao.svg" alt />
              <h2>Educação</h2>
            </div>
          </section>
          <section class="advantage__grid__item" @click="goTo('lazer')">
            <div class="advantage__grid__item__wrapper">
              <img src="@/assets/beneficios/lazer.svg" alt />
              <h2>Lazer</h2>
            </div>
          </section>
        </div>
        <div class="advantage__grid-content">
          <section
            :class="[
              'advantage__grid-content__item advantage__grid-content__item--saude',
              { 'advantage__grid-content__item--active': itens.saude },
            ]"
            @click="goTo('saude')"
          >
            <p>
              O Cartão de TODOS tem clínicas e laboratórios parceiros em todo o
              Brasil para consultas em diversas especialidades e mais de 1.500
              exames laboratoriais e de imagem.
            </p>
          </section>
          <section
            :class="[
              'advantage__grid-content__item',
              { 'advantage__grid-content__item--active': itens.educacao },
            ]"
            @click="goTo('educacao')"
          >
            <p>
              Toda a sua família também tem acesso a uma rede de ensino
              qualificado, com ótimos descontos em escolas, faculdades, cursos
              técnicos e profissionalizantes.
            </p>
          </section>
          <section
            :class="[
              'advantage__grid-content__item',
              { 'advantage__grid-content__item--active': itens.lazer },
            ]"
            @click="goTo('lazer')"
          >
            <p>
              E quem tem saúde pode viajar tranquilo e se divertir com descontos
              incríveis em pousadas, colônias de férias, academias e clubes.
            </p>
          </section>
        </div>
      </div>

      <div class="advantage__title">
        <h3>Descontos Especiais do Bahia.</h3>
      </div>
      <div class="limit-grid3">
        <section class="advantage__card">
          <figure>
            <img src="@/assets/beneficios/especiais.svg" alt />
          </figure>
          <div class="advantage__card__text">
            <h4>Especiais</h4>
            <p>
              Em breve compartilharemos descontos em benefícios especiais para
              os filiados ao Cartão de TODOS Bahia.
            </p>
          </div>
        </section>
        <section class="advantage__card">
          <figure>
            <img src="@/assets/beneficios/saude2.svg" alt />
          </figure>
          <div class="advantage__card__text">
            <h4>Saúde</h4>
            <p>
              São mais de 250 clínicas médicas e odontológicas e mais de 1.500
              exames a preços acessíveis para o seu bolso, além de descontos
              especiais em farmácias.
            </p>
          </div>
        </section>
        <section class="advantage__card">
          <figure>
            <img src="@/assets/beneficios/educacao2.svg" alt />
          </figure>
          <div class="advantage__card__text">
            <h4>Educação</h4>
            <p>
              Você pode impulsionar sua carreira com os cursos
              profissionalizantes e preparatórios do PreparaTODOS, além de
              descontos em mais de 67 universidades, escolas de idiomas e cursos
              técnicos.
            </p>
          </div>
        </section>
        <section class="advantage__card">
          <figure>
            <img src="@/assets/beneficios/lazer2.svg" alt />
          </figure>
          <div class="advantage__card__text">
            <h4>lazer</h4>
            <p>
              Aproveite descontos e preços especiais em viagens, hotéis,
              parques, lojas, restaurantes, academias e clubes.
            </p>
          </div>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  title() {
    return `Benefícios | Cartão de TODOS Clube do Bahia`;
  },
  data() {
    return {
      itens: {
        saude: false,
        educacao: false,
        lazer: false,
      },
    };
  },
  methods: {
    goTo(item) {
      switch (item) {
        case "saude":
          this.itens.saude = !this.itens.saude;
          this.itens.educacao = false;
          this.itens.lazer = false;
          break;
        case "educacao":
          this.itens.saude = false;
          this.itens.educacao = !this.itens.educacao;
          this.itens.lazer = false;
          break;
        case "lazer":
          this.itens.saude = false;
          this.itens.educacao = false;
          this.itens.lazer = !this.itens.lazer;
          break;
      }
    },
  },
};
</script>

<style lang="scss">
.advantage {
  padding-top: 68px;
  padding-bottom: 100px;
  background: $color-primary;
  position: relative;
  z-index: 10;
  margin-bottom: -1px;
  @include media(">=tablet") {
    padding-top: 105px;
    padding-bottom: 100px;
    margin-bottom: initial;
  }

  &__banner {
    position: relative;
    object-fit: cover;
    width: 100%;
    height: 204px;
    background: url("../assets/banners/banner02-mobile.jpg") $color-primary
      no-repeat center top;
    background-size: 100% auto;
    @include media(">=tablet") {
      height: 400px;
      background: url("../assets/banners/banner02.jpg") $color-primary no-repeat
        center center;
      background-size: cover;
    }
    h1 {
      padding-top: 25px;
      text-align: center;
      color: $color-white;
      font-family: "Arvo", sans-serif;
      font-weight: 700;
      font-size: 17px;
      line-height: 20px;
      text-transform: uppercase;
      @include media(">=tablet") {
        padding-top: 91px;
        font-size: 40px;
        line-height: 49px;
      }
    }
  }
  &__wrapper {
    position: relative;
  }
  &__grid {
    display: grid;
    grid-template-columns: repeat(3, 33.33%);
    position: relative;
    margin-top: -123px;
    @include media(">=tablet") {
      margin-top: -183px;
      fill: black;
    }
    &__item {
      text-align: center;
      width: 100%;
      height: 100px;
      position: relative;
      background: #1583e6;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1;
      transition: 0.5s ease-in-out;
      @include media(">=tablet") {
        height: 366px;
        &:hover {
          img {
            transform: scale(1.2);
          }
        }
      }
      img {
        max-height: 33px;
        flex: 1 0 100%;
        transition: 0.3s ease-in-out;
        @include media(">=tablet") {
          max-height: 122px;
        }
      }
      &__wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        height: 58px;
        @include media(">=tablet") {
          height: 222.24px;
        }
        h2 {
          align-self: flex-end;
        }
      }
      &:nth-child(2) {
        background: #1166b4;
        .advantage__grid__item__content {
          background: #1166b4;
        }
      }
      &:last-child {
        background: #0c4e8b;
        .advantage__grid__item__content {
          background: #0c4e8b;
        }
      }
      h2 {
        color: $color-white;
        font-family: "Arvo", sans-serif;
        font-weight: 700;
        font-size: 9px;
        @include media(">=tablet") {
          font-size: 40px;
        }
      }
    }
    &-content {
      display: grid;
      grid-template-columns: 1fr;
      box-sizing: border-box;
      opacity: 1;
      transition: 0.3s ease-in-out;
      @include media(">=tablet") {
        position: absolute;
        top: 0;
        grid-template-columns: repeat(3, 33.33%);
        width: 100%;
        height: 366px;
      }

      &__item {
        opacity: 0;
        background: #1583e6;
        transition: 0.3s ease-in-out;
        overflow: hidden;
        max-height: 0;
        max-width: calc(100vw - 70px);
        @include media(">=tablet") {
          cursor: pointer;
          max-height: initial;
          max-width: initial;
        }
        &--active {
          opacity: 1;
          max-height: 500px;
          z-index: 2;
        }

        &:nth-child(2) {
          background: #1166b4;
        }
        &:last-child {
          background: #0c4e8b;
        }
        p {
          color: $color-white;
          font-family: "Arvo", sans-serif;
          font-weight: 700;
          text-align: left;
          font-size: 14px;
          line-height: 16px;
          padding: 20px;
          @include media(">=tablet") {
            font-size: 20px;
            line-height: 25px;
            padding: 61px 33px;
          }
        }
      }
    }
  }

  &__title {
    margin: 30px 0 8px 0;
    @include media(">=tablet") {
      margin: 160px 0 43px 0;
    }
    h3 {
      text-align: center;
      color: $color-white;
      font-family: "Arvo", sans-serif;
      font-weight: 700;
      font-size: 17px;
      line-height: 20px;
      text-transform: uppercase;
      padding: 20px 40px;
      @include media(">=tablet") {
        font-size: 40px;
        line-height: 49px;
        padding: initial;
      }
    }
  }

  &__card {
    display: grid;
    grid-template-columns: 86px auto;
    grid-gap: 16px;
    background: #1166b4;
    text-align: center;
    height: initial;
    align-items: center;
    padding: 20px 12px;
    margin-top: 20px;
    @include media(">=tablet") {
      padding: 0 45px;
      height: 360px;
      grid-template-columns: 240px auto;
      grid-gap: 56px;
    }
    figure {
      margin: 0;
      img {
        max-width: 100%;
        @include media("<=small") {
          max-height: 52px;
        }
      }
    }

    &__text {
      text-align: left;
      max-width: 527px;

      h4 {
        text-transform: uppercase;
        font-family: "Arvo", sans-serif;
        font-weight: 700;
        font-size: 18px;
        line-height: 21px;
        color: $color-yellow;
        @include media(">=tablet") {
          font-size: 40px;
          line-height: 49px;
        }
      }

      p {
        margin: 5px;
        font-family: "Arvo", sans-serif;
        font-weight: 700;
        font-size: 14px;
        line-height: 16px;
        color: $color-white;
        margin-top: 0px;
        @include media(">=tablet") {
          font-size: 30px;
          line-height: 37px;
        }
      }
    }
  }
}
</style>
